import { normalizeStatusList } from './../shared/utils';

export const buildQueryParams = ({
  jobsTeamSharingFeatureEnabled,
  organizationId,
  ownership = {},
  statusList,
  username,
}) => {
  const defaultParams = {
    limit: 50,
  };

  if (jobsTeamSharingFeatureEnabled) {
    if (ownership.type === 'team') {
      return {
        ...defaultParams,
        team_id: ownership.name,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'organization') {
      return {
        ...defaultParams,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
      };
    }

    if (ownership.type === 'user') {
      return {
        ...defaultParams,
        org_id: organizationId,
        owner: ownership.name || username,
        ...normalizeStatusList(statusList),
      };
    }

    return {
      ...defaultParams,
      ...normalizeStatusList(statusList),
    };
  }

  if (ownership.type === 'organization') {
    return {
      ...defaultParams,
      username,
      owner_type: 'organization',
      ...normalizeStatusList(statusList),
    };
  }

  return {
    ...defaultParams,
    username,
    owner_type: 'user',
    owner: ownership.name || username,
    ...normalizeStatusList(statusList),
  };
};
